import PaymentPlan from 'features/payOverTime/screens/application/PaymentPlan/PaymentPlan';
import React from 'react';

export default function Page() {
  return <PaymentPlan />;
}
